






































import { Component, Vue } from 'vue-property-decorator'

import { BRow, BCol } from 'bootstrap-vue'

@Component({
  components: { BRow, BCol }
})
export default class HomePage extends Vue {}
